var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfxQ4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_6831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.3036 30 30 23.3036 30 15C30 6.69643 23.3036 0 15 0C6.69643 0 0 6.69643 0 15C0 23.3036 6.69643 30 15 30Z",
    fill: "#0098EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.141 8.35742H9.8553C7.9803 8.35742 6.80172 10.3931 7.71244 12.0539L14.0339 23.036C14.4624 23.7324 15.4803 23.7324 15.9089 23.036L22.2303 12.0539C23.1946 10.3931 22.016 8.35742 20.141 8.35742ZM14.0874 19.7146L12.6946 17.036L9.37315 11.0896C9.15887 10.7146 9.42672 10.2324 9.90887 10.2324H14.0874V19.7146ZM20.6232 11.0896L17.3017 17.036L15.9089 19.7146V10.2324H20.0874C20.5696 10.2324 20.8374 10.7146 20.6232 11.0896Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_6831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfxQ4);
export default __webpack_public_path__ + "static/media/bfx_q (4).1aa41504112ea774557afd744d8f421c.svg";
export { ForwardRef as ReactComponent };